var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import Box from "../Box";
import Button from "../Button";
import DropDown from "../DropDown";
import { messages } from "../../messages";
import ToggleInput from "../ToggleInput";
var SongFilter = /** @class */ (function (_super) {
    __extends(SongFilter, _super);
    function SongFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = _this.toggle.bind(_this);
        _this.state = {
            dropdownOpen: false,
            inputValueStart: props.bpm_min || 0,
            inputValueEnd: props.bpm_max || 250,
            songVersion: props.songVersion,
            sortBy: props.sortBy,
            key: props.selectedKey,
            hideRemix: props.hideRemixes
        };
        _this.onSongSelected = _this.onSongSelected.bind(_this);
        _this.onSortByChange = _this.onSortByChange.bind(_this);
        _this.onKeyChange = _this.onKeyChange.bind(_this);
        return _this;
    }
    SongFilter.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.bpm_min != prevProps.bpm_min || this.props.bpm_max != prevProps.bpm_max
            || this.props.selectedKey != prevProps.selectedKey || this.props.hideRemixes != prevProps.hideRemixes
            || (this.props.sortBy == undefined && prevProps.sortBy != undefined
                || this.props.sortBy == undefined && prevProps.sortBy != undefined ||
                this.props.sortBy != undefined && prevProps.sortBy != undefined &&
                    this.props.sortBy.id != prevProps.sortBy.id)) {
            this.setState({
                sortBy: this.props.sortBy,
                key: this.props.selectedKey,
                hideRemix: this.props.hideRemixes,
                inputValueStart: this.props.bpm_min || 0, inputValueEnd: this.props.bpm_max || 250
            });
        }
    };
    SongFilter.prototype.onSongSelected = function (value) {
        this.setState({ songVersion: value });
    };
    SongFilter.prototype.onSortByChange = function (value) {
        this.setState({ sortBy: value });
    };
    SongFilter.prototype.onKeyChange = function (value) {
        this.setState({ key: value });
    };
    SongFilter.prototype.toggle = function () {
        this.setState(function (prevState) { return ({
            dropdownOpen: !prevState.dropdownOpen
        }); });
    };
    SongFilter.prototype.handleChangeStart = function (event) {
        if (event.target.value > 250) {
            this.setState({ inputValueStart: 250 });
        }
        else {
            this.setState({ inputValueStart: event.target.value });
        }
    };
    SongFilter.prototype.handleChangeEnd = function (event) {
        if (event.target.value > 250) {
            this.setState({ inputValueEnd: 250 });
        }
        else {
            this.setState({ inputValueEnd: event.target.value });
        }
    };
    SongFilter.prototype.onResetPress = function () {
        this.setState({
            inputValueStart: 0,
            inputValueEnd: 250,
            songVersion: undefined,
            sortBy: undefined,
            key: undefined,
            hideRemix: this.props.hideRemixes != undefined ? false : undefined
        });
        this.props.onSubmitPress();
        this.props.onReset && this.props.onReset();
    };
    SongFilter.prototype.renderContent = function () {
        var _this = this;
        return React.createElement(React.Fragment, null,
            React.createElement("div", { style: { display: 'flex' } },
                React.createElement("div", null,
                    React.createElement("h3", null, messages.ShowOnly)),
                this.props.hideRemixes !== undefined && React.createElement("div", { style: { marginLeft: 'auto', display: 'flex', alignItems: 'center' } },
                    React.createElement("span", { style: { maxWidth: 80, paddingRight: 10, lineHeight: '16px', display: 'block' }, className: "my-auto switch-label-column" },
                        React.createElement("span", { className: "text-secondary" }, messages.HideRemix)),
                    React.createElement(ToggleInput, { checked: this.state.hideRemix, onChange: function (e) {
                            _this.setState({ hideRemix: e.target.checked }, function () {
                                _this.props.onSubmitPress(_this.state.inputValueStart, _this.state.inputValueEnd, _this.state.songVersion, _this.state.sortBy, _this.state.key, _this.state.hideRemix);
                            });
                        } }))),
            React.createElement(DropDown, { style: { marginTop: '20px' }, selectText: messages.SongVersion, dataSource: this.props.songVersions, keyExtractor: function (t) { return t; }, valueExtractor: function (t) { return t; }, onValueSelected: this.onSongSelected, selected: this.state.songVersion }),
            React.createElement("div", { style: { marginTop: 20 } },
                React.createElement("h5", { className: "title-filter-bpm" }, messages.BPM),
                React.createElement("span", { className: "bpm-filter-div" },
                    React.createElement("input", { value: this.state.inputValueStart, onChange: this.handleChangeStart.bind(this), className: "input-field", type: "text" }),
                    React.createElement("div", { className: "text-between" }, messages.to),
                    React.createElement("input", { value: this.state.inputValueEnd, onChange: this.handleChangeEnd.bind(this), className: "input-field", type: "text" }))),
            this.props.keys != undefined && React.createElement(DropDown, { style: { marginTop: '20px' }, selectText: messages.Key, dataSource: this.props.keys, keyExtractor: function (t) { return t; }, valueExtractor: function (t) { return t; }, onValueSelected: this.onKeyChange, selected: this.state.key }),
            React.createElement(DropDown, { style: { marginTop: '20px' }, selectText: messages.Relevance, dataSource: this.props.sortBys, keyExtractor: function (t) { return t.id.toString(); }, valueExtractor: function (t) { return t.name; }, onValueSelected: this.onSortByChange, selected: this.state.sortBy }),
            React.createElement("div", { style: { marginTop: '20px' } },
                React.createElement("span", null,
                    React.createElement(Button, { selected: true, color: "blue", onClick: function () { return _this.props.onSubmitPress(_this.state.inputValueStart, _this.state.inputValueEnd, _this.state.songVersion, _this.state.sortBy, _this.state.key, _this.state.hideRemix); }, className: "submit btn-filter btn-submit", text: messages.Submit }),
                    React.createElement(Button, { onClick: function () { return _this.onResetPress(); }, className: "reset btn-filter", color: "blue", text: messages.Reset }))));
    };
    SongFilter.prototype.render = function () {
        if (this.props.noBox) {
            return React.createElement("div", { style: this.props.style, className: 'song-filter' }, this.renderContent());
        }
        return (React.createElement(Box, { style: this.props.style, className: 'song-filter' }, this.renderContent()));
    };
    return SongFilter;
}(React.Component));
export default SongFilter;
//# sourceMappingURL=SongFilter.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/filter/SongFilter.js
// module id = 477
// module chunks = 0